module.exports = __webpack_public_path__ + "img/nodeBackgroundFull.56af1968.svg";